import homeHero from "./home_hero_1.png";
import homeCards from "./home_cards_1.png";
import feature from "./feature_1.png";
import expo from "./expo.png";
import expo02 from "./expo02.png";
import javascript from "./javascript.png";
import react from "./react.png";
import scene from "./scene_1.png";
import mockup from "./mockup_1.png";
import logo from "./logo135.png";
import banner from "./banner.svg";
import banner02 from "./banner02.svg";
import banner03 from "./banner03.svg";
import banner04 from "./banner04.svg";
import arrow from './arrow.png'
export default {
  homeHero,
  homeCards,
  feature,
  expo,
  expo02,
  javascript,
  react,
  scene,
  mockup,
  logo,
  arrow,
  banner,
  banner02,
  banner03,
  banner04,
};
